<template>
    <div class="amount-input-wrapper">
        <amount-unit-tip
            :value="realValue"
            :style="{ left: prefixIcon ? '18px' : '3px' }"
        />
        <el-input
            v-model="displayValue"
            :class="['prefix', customClass]"
            :placeholder="placeholder"
            :maxlength="20"
            :disabled="disabled"
            :prefix-icon="prefixIcon"
            @input="handleInput"
            @blur="$emit('blur', $event)"
            @focus="$emit('focus', $event)"
        />
    </div>
</template>

<script>
import AmountUnitTip from "@/components/common/amountUnitTip.vue";

export default {
    name: "AmountInput",
    components: {
        AmountUnitTip
    },
    props: {
        // 真实值（纯数字，用于 v-model 双向绑定）
        value: {
            type: [String, Number],
            default: ""
        },
        // 占位符
        placeholder: {
            type: String,
            default: "请输入金额"
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        },
        // 前缀图标（金额类输入默认显示 fa fa-jpy，份额类输入传空字符串）
        prefixIcon: {
            type: String,
            default: "fa fa-jpy"
        },
        // 自定义类名
        customClass: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            displayValue: "" // 显示值（带千位分隔符）
        };
    },
    computed: {
        // 真实值（纯数字）
        realValue() {
            return this.value;
        }
    },
    watch: {
        // 监听外部值变化（如快速选择按钮、程序赋值）
        value: {
            handler(newVal) {
                if (newVal) {
                    const formatted = this.formatWithCommas(newVal);
                    // 只有当格式化后的值与当前显示值不同时才更新
                    if (formatted !== this.displayValue) {
                        this.displayValue = formatted;
                    }
                } else {
                    this.displayValue = "";
                }
            },
            immediate: true
        }
    },
    methods: {
        // 处理输入事件
        handleInput(value) {
            // 1. 移除所有非数字和非小数点的字符
            let raw = value.replace(/[^\d.]/g, "");

            // 2. 确保只有一个小数点（合并多余小数点）
            const dotParts = raw.split(".");
            raw = dotParts[0];
            if (dotParts.length > 1) {
                raw = raw + "." + dotParts.slice(1).join("");
            }

            // 3. 限制小数位数（最多2位）和整数部分长度（最多14位）
            const parts = raw.split(".");
            // 处理整数部分超长
            if (parts[0].length > 14) {
                parts[0] = parts[0].substring(0, 14);
            }
            // 处理小数部分超长（需要在整数截断后重新组装）
            if (parts[1] && parts[1].length > 2) {
                parts[1] = parts[1].substring(0, 2);
            }
            // 重新组装 raw
            raw = parts[0];
            if (parts[1] !== undefined) {
                raw = raw + "." + parts[1];
            }

            // 4. 更新显示值（添加千位分隔符）
            if (raw) {
                this.displayValue = this.formatWithCommas(raw);
            } else {
                this.displayValue = "";
            }

            // 5. 触发 input 事件，更新 v-model 的真实值
            this.$emit("input", raw);
        },
        // 格式化数字添加千位分隔符
        formatWithCommas(value) {
            if (!value) return "";
            const num = value.toString();
            const parts = num.split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }
    }
};
</script>

<style lang="scss" scoped>
.amount-input-wrapper {
    position: relative;
    display: inline-block;
}

::v-deep .prefix .el-input__inner {
    text-align: left;
}
</style>
